import { render, staticRenderFns } from "./RemoveRetailPackagingDisplay.vue?vue&type=template&id=b2f1fd86&scoped=true&"
import script from "./RemoveRetailPackagingDisplay.vue?vue&type=script&lang=js&"
export * from "./RemoveRetailPackagingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f1fd86",
  null
  
)

export default component.exports